module.exports = {
  plus: [{
    text: 'מאוד לא מדוייק',
    score: 1,
    color: 1
  }, {
    text: 'לא מדוייק',
    score: 2,
    color: 2
  }, {
    text: 'נייטרלי',
    score: 3,
    color: 3
  }, {
    text: 'מדוייק במידה סבירה',
    score: 4,
    color: 4
  }, {
    text: 'מאוד מדוייק',
    score: 5,
    color: 5
  }],
  minus: [{
    text: 'מאוד לא מדוייק',
    score: 5,
    color: 1
  }, {
    text: 'לא מדוייק',
    score: 4,
    color: 2
  }, {
    text: 'נייטרלי',
    score: 3,
    color: 3
  }, {
    text: 'מדוייק במידה סבירה',
    score: 2,
    color: 4
  }, {
    text: 'מאוד מדוייק',
    score: 1,
    color: 5
  }]
};